import React from 'react';
import { SourceApp, DeploymentType, IConfig } from "../../../Config";

import TestYourself from '../../../learning-components/testYourself/TestYourself';
import './test-yourself.scss';
import { liveTestVersion } from '../../../learning-components/testYourself/constants';

export interface IProps {
    deploymentType: DeploymentType;
    sourceApp: SourceApp;
    
    handleShowTestYourselfModal: () => void;
    modalOpen: boolean;
}
export interface IState {}

export class ManningOnlineCatalogTestYourself extends React.Component <IProps, IState> {
    
    private key = Math.random();
    // private bookChapter: string = 'chapter-4';
    // private bookId: number = 1326;
    // private bookShortName: string = 'Deep Learning with JavaScript';
    private currentQuestionIndex: number = 0;
    private currentScore: number = 0;
    // private deploymentType: number = 0; // 0 = dev, 1 = qa, 2 = prod, 3 = docker, 4 = test
    private examSessionId: number = 1158;
    private firstQuestion: any = {
        "id": 1,
        "guid": null,
        "productId": 123,
        "elementShortName": "chapter-1",
        "interactiveFeatureType": "CLOZED_DELETION_WITH_SUGGESTIONS",
        "description": "This is a question about chapter 1",
        "featureContent": {
            "terms": [
                {
                    "clozed-term": "Pandas",
                    "distractors": [
                        "Blorkfish",
                        "FORTRAN"
                    ]
                }
            ],
            "text": "|--Pandas--| is a useful Python package to open, manipulate, and save datasets."
        },
        "technology": "pandas",
        "topic": "datasets",
        "keywords": [
            "pandas",
            "datasets",
            "Python"
        ],
        "level": null,
        "section": null,
        "importance": 0,
        "potentialScores": [
            10,
            4,
            1
        ],
        "previousAttempts": 0
    };
    private uuid: string = null;
    private maxQuestions: number = null;
    private remainingQuestions: number = null;
    private showWelcomeScreen: boolean = true;
    private sessionData: any = [
        {
            "title": null,
            "numQuestions": 3,
            "questionsDone": "NONE",
            "currentScore": null,
            "maxScore": 30,
            "isCurrent": true,
            "seenQuestions": 1,
            "questionsSolvedOnFirstTry": 0
        },
        {
            "title": "1 Getting started with ASP.NET Core",
            "numQuestions": 0,
            "questionsDone": "ALL",
            "currentScore": null,
            "maxScore": null,
            "isCurrent": false,
            "seenQuestions": 0,
            "questionsSolvedOnFirstTry": 0
        }
    ]
    private totalQuestions: number = null;
    private userDetails: any = {}
    private userOwnsBook: boolean = true;
    private readerTrackingUpdateData: any = null;
    private welcomeScreenSeen: boolean = false;
    private handleEndScreen: any = () => {};
    private handleWelcomeScreenSeen: any = () => {};

    readonly state: IState = {
        showModal: true
    }

    constructor(props: IProps) {
        super(props);
    }

    public componentDidMount(){}

    public componentWillUnmount(){}

    public render(){
        return <div>
                    <div className='ready-to-test-yourself-modal'>
                        <div className="ready-to-test-yourself-modal__content">
                            <button className='ready-to-test-yourself-close-btn' style={{ zIndex: 9 }} onClick={() => this.props.handleShowTestYourselfModal()}></button>
                            <TestYourself 
                                bookChapter={null}
                                bookId={null}
                                bookShortName={null}
                                currentQuestionIndex={this.currentQuestionIndex} 
                                currentScore={this.currentScore} 
                                deploymentType={this.props.deploymentType}
                                examSessionId={this.examSessionId} 
                                firstQuestion={this.firstQuestion} 
                                guid={this.uuid}
                                handleEndScreen={() => this.handleEndScreen()} 
                                handleHideFinishedScreen={this.key}
                                handleWelcomeScreenSeen={(data) => this.handleWelcomeScreenSeen(data)} 
                                key={this.key} 
                                maxQuestions={this.maxQuestions}
                                remainingQuestions={this.remainingQuestions} 
                                showWelcomeScreen={this.showWelcomeScreen} 
                                subscriptionTracking={this.readerTrackingUpdateData} 
                                testplorerData={this.sessionData} 
                                totalQuestions={this.totalQuestions} 
                                userDetails={this.userDetails}
                                userOwnsBook={this.userOwnsBook}
                                welcomeScreenSeen={this.welcomeScreenSeen}
                                justifyContent='start'
                                sourceApp={2} // 0 = demo, 1 = marketplace, 2 = livebook, 3 = livevideo, 4 = pbc
                                version={liveTestVersion.SUBSCRIPTION_VERSION}
                                preselectedQuestions={null}
                                sessionExists={false}
                                updateSessionExists={() => {}}
                                userIsAdmin={true}
                                isCFT={false}
                                inMarketplace={false}
                                />
                        </div>
                    </div>
                </div>
    }
}